// export const getFlowConfig = state => state.CheckoutPage.flowConfig ;
export const globalData = state => state.ProspectWidgets_GlobalData;
